export const getRelatedProductsQuery = `
  query getRelatedProductsById($ids: [ID!]!){
          nodes(ids: $ids){
            id
            ... on Product {
              title
              handle
              tags
              productType
              totalInventory
              featuredImage {
                url
                altText
              }
              priceRange {
                maxVariantPrice {
                  amount
                }
              }
              variants(first: 1) {
                nodes{
                  id
                  price {
                    amount
                  }
                }
              }
            }
          }
        }
`
